import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from '../../styles.module.scss';
export var InstructionElement = function (_a) {
    var index = _a.index, children = _a.children;
    return (_jsxs("p", { className: styles.instruction, children: [index && _jsx("span", { className: styles['instruction-number'], children: index }), _jsx("span", { children: children })] }));
};
